import { Icons } from "../components/ui/icons";
import { UserRole } from "./enums";

export type NavIcon = typeof Icons.Dashboard;

export interface NavItemConfig {
  href: string;
  label: string;
  icon: NavIcon;
  /** Only these roles see the item; omit to show to everyone. */
  roles?: UserRole[];
  isActive?: (pathname: string) => boolean;
}

export const MAIN_NAV_ITEMS: NavItemConfig[] = [
  { href: "/", label: "Dashboard", icon: Icons.Dashboard },
  { href: "/customers", label: "Customers", icon: Icons.Clients },
  { href: "/sites", label: "Sites", icon: Icons.Building },
  { href: "/warehouses", label: "Warehouses", icon: Icons.Billing },
  { href: "/inventory", label: "Inventory", icon: Icons.Inventory },
  { href: "/ppe", label: "PPE/Non Scaffolds", icon: Icons.Inventory },
  { href: "/activities", label: "Movements", icon: Icons.Movement },
  {
    href: "/mobile-app",
    label: "Mobile App",
    icon: Icons.Deliveries,
    isActive: (pathname) => pathname.startsWith("/mobile-app"),
  },
  { href: "/vendors", label: "Vendors", icon: Icons.Building },
  { href: "/quotes", label: "Quotes", icon: Icons.Quotes },
  { href: "/invoices", label: "Invoices", icon: Icons.Billing },
  {
    href: "/users",
    label: "Users",
    icon: Icons.Candidate,
    roles: [UserRole.MANAGEMENT, UserRole.ADMIN],
  },
];

export const ACCOUNT_NAV_ITEMS: NavItemConfig[] = [
  { href: "/reporting", label: "Reporting", icon: Icons.Reporting },
  { href: "/reminders", label: "Reminders", icon: Icons.Bell },
  { href: "/assets", label: "Fixed Assets", icon: Icons.Document },
  { href: "/settings", label: "Settings", icon: Icons.Settings, roles: [UserRole.ADMIN] },
];

export const isNavItemActive = (item: NavItemConfig, pathname: string) =>
  item.isActive ? item.isActive(pathname) : pathname === item.href;

export const canSeeNavItem = (item: NavItemConfig, role?: string | null) =>
  !item.roles || (!!role && item.roles.includes(role as UserRole));

export const getUserInitials = (fullName?: string | null) => {
  if (!fullName) return "?";
  const names = fullName.trim().split(/\s+/);
  return [names[0]?.[0], names[names.length - 1]?.[0]]
    .filter(Boolean)
    .join("")
    .toUpperCase();
};
